import React, { Component } from 'react';
// import { withRouter } from 'react-router-dom';
import { useParams, useNavigate } from 'react-router-dom';

import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import $ from 'jquery';
import Select from 'react-select';
import { lang } from '../Helpers/lang';
import { PageTitle, CheckAuth,scrollToTop } from "../Helpers/SettingHelper";
import { apiUrl, mediaUrl} from'../Config/Config';
import axios from 'axios';


		const withRouter = WrappedComponent => props => {
			const params = useParams();
			const  navigate = useNavigate();
			// etc... other react-router-dom v6 hooks
		  
			return (
			  <WrappedComponent
				{...props}
				params={params}
				navigate ={navigate}
				// etc...
			  />
			);
		  };

class Edit extends Component {

	constructor(props)
	{
		CheckAuth();
		super(props);	
		
	    const submenuid = (typeof props.params.ID === 'undefined') ? '' : props.params.ID;
		this.state = {
            submenuid: submenuid,
			selSubmenuOption:'',
			selSubmenuValue:'',
			selSubmenuFunc:'',
			selSubmenuLabel:'',	
			selectedOption:{ value: 'active', label: 'Active'},
			selectedvalue:'active',
			loggedInChecked:false,
			loggedSt:'Both',		
			accessType:'Both',		

			submenuName: '',
			priority: '',
			image_preview:'',
			image_name:'',
			image:'',
			fileExtension: '',
			old_image:'',
			editid:0,
		};
		var qs = require('qs');
		var catid = this.state.submenuid;

		axios.get(apiUrl+"submenumanagement/listdetail?id="+catid).then(res => {			
			if(res.data.submenulist.status === 'A'){
				this.setState({selectedOption:{value: 'active', label: 'Active'}});
			}else{
				this.setState({selectedOption:{value: 'inactive', label: 'Inactive'}});
			}			
			// if(res.data.submenulist.isLogged == 'true'){
			// 	this.setState({loggedInChecked: true});
			// }else{
			// 	this.setState({loggedInChecked:false});
			// }			
			this.setState({selSubmenuOption:{value: res.data.submenulist.slug, label: res.data.submenulist.name}});
			this.setState({  selSubmenuValue : res.data.submenulist.slug, selSubmenuFunc : res.data.submenulist.funcName, submenuName : res.data.submenulist.name, priority : res.data.submenulist.priority, image_preview:res.data.submenulist.image,old_image:res.data.submenulist.image, editid:1, loggedSt : res.data.submenulist.isLogged, accessType: res.data.submenulist.accessType});
		}); 

		
		
		this.handleInputChange = this.handleInputChange.bind(this);
	    this.handleChange = this.handleChange.bind(this);
		this.onChangeHandler = this.onChangeHandler.bind(this);
		this.handleOptionChange = this.handleOptionChange.bind(this);

    }

    handleChange = selectedOption => {
        this.setState({selectedOption})
        this.setState({  selectedvalue : selectedOption.value});
    };
	handleOptionChange = selSubmenuOption => {
        this.setState({selSubmenuOption})
        this.setState({  selSubmenuLabel : selSubmenuOption.label, selSubmenuValue : selSubmenuOption.value, selSubmenuFunc : selSubmenuOption.func});
   	};
   	handleInputChange(event) {
		const {name, value} = event.target;      
		this.setState({
			[name]: value
		});      		
		if(name === 'loggedIn'){
			this.setState({loggedInChecked: !this.state.loggedInChecked});
		}	
    }
	onChangeHandler=event=>{
		let reader = new FileReader();
		const file = event.target.files[0];
		const extension = file.name.split('.').pop();
		reader.onloadend = () => {
		  this.setState({
			image_name: file.name,
			image_preview: reader.result,
			image: file,
			fileExtension:extension,editid:0
		  });
		};
		reader.readAsDataURL(file);
	}

	componentDidMount() {
		document.title = PageTitle('Submenu Edit');
    }

	
	handleFormSubmit = () => {
		if(this.validateForm()){ 
			this.setState({Loading:true});
			const config = {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
				};
			const formPayload = this.state;
			var qs = require('qs');
			var status = '';
			if(formPayload.selectedvalue === '' && formPayload.selectedvalue!== 0){
			status =formPayload.selectedOption.value;
			}else{
			status = formPayload.selectedvalue;
			}

			var postObject = {
				admin_id : localStorage.getItem("admin_id"),
				name : formPayload.submenuName,
				slug : formPayload.selSubmenuValue,
				funcName : formPayload.selSubmenuFunc,
				loggedInChecked : formPayload.loggedSt,
				accessType : formPayload.accessType,
				status:  status,
				old_image: formPayload.old_image,
				editid:  this.state.editid,
				image: this.state.editid===0 ? formPayload.image:'',
				priority: formPayload.priority,
				id: formPayload.submenuid,
			
			};
			let formData = new FormData();
			for(let k in postObject) {
			formData.append(k, postObject[k]);
			}		       
			axios.post(apiUrl+"submenumanagement/edit",formData ).then(res => {
				if(res.data.status === "success"){	
					$('.success_message').html('<div class="status_sucess"><h3>'+res.data.message+'</h3></div>');
					setTimeout(
					function() {
						$('.success_message').html(this.props.navigate('/menumanagement'));
					}
					.bind(this),
					3000
					);
				}else{
					$('.success_message').html('<div class="status_sucess"><h3>'+res.data.message+'</h3></div>');
					
					setTimeout(
					function() {
						$('.success_message').html('');
					}
					.bind(this),
					3000
					);
				}
			});
		}
	}

	validateForm() {
		//const {admin_company_name,admin_fname} = this.state;
		const {selSubmenuValue} = this.state;
		let errors = {};
      	let formIsValid = true;
		
		if (!selSubmenuValue) {
			formIsValid = false;
			$('.errorselSubmenuValue').html('<span class="errorspan">Please fill the field</span>');
		}else if(selSubmenuValue){
			$('.errorselSubmenuValue').html('');
		}


		this.setState({
			errors: errors
		});
		return formIsValid;
    }

render() {

  	const {selectedOption, selSubmenuOption} = this.state;
	if(this.state.editid==1){		
		var loaderimg = mediaUrl + '/submenu/'+this.state.image_preview;
		var preview = <img className="img_class" src={loaderimg} alt="" />;
	}else {
	
		
		console.log(2)
		var	preview = <img className="img_class" src={this.state.image_preview} alt="" />;

	}
    return (
		<div className="wrapper"> 
	
		<Header />
		<MenuSidebar currentpage="menumanagement" />  
			<div className="content">	
				<div className="content-wrapper">
					<div class="content-wrapper-before"></div>
					<div className="form-wrapper leaa-admin-head card">
						<div className="success_message"></div>
						<div className="content-wrapper">
							<a href="/menumanagement" >Back</a>   
						</div>
						<div className="title">
							<h4>Edit menu</h4>
						</div>
						<form className="edit" id="edit" onSubmit={ e => { this.handleFormSubmit(this); e.preventDefault(); }} encType="multipart/form-data">
							<div className="form-row">
								<div className="form-left">
									<div className="form-group">
										<label>Menu Name<span class="required" style={{ color: "red" }} >* </span> : </label>
										<input type="text" name="submenuName" onChange={this.handleInputChange} className="form-control" value={this.state.submenuName}/>
										<div className="errorsubmenuName"></div>
									</div>
									<div className="form-group">
										<label>Link to<span class="required" style={{ color: "red" }} > * </span> :</label>
										<Select 
										name="status"
										value={selSubmenuOption?selSubmenuOption:{ value: '', label: 'Select'}}
										options={lang.common.submenu_option} 
										isSearchable = {false}
										onChange={this.handleOptionChange}
										/>
										<div className="errorselSubmenuValue"></div>
									</div>

									<div className="form-group" style={{ marginTop: '20px' }}>										
										<label>User Access :</label>

										<input onChange={this.handleInputChange} type="radio" name="loggedSt" value="Guest" checked={(this.state.loggedSt == "Guest" ? "checked" : "" )}/>
										Guest
										<input onChange={this.handleInputChange} type="radio"  name="loggedSt" value="Logged In" checked={(this.state.loggedSt == "Logged In" ? "checked" : "" )}/>
										Logged In
										<input onChange={this.handleInputChange} type="radio"  name="loggedSt" value="Both" checked={(this.state.loggedSt == "Both" ? "checked" : "" )}/>
										Both	
									</div> 
									<div className="form-group" style={{ marginTop: '20px' }}>										
										<label>Access Type :</label>

										<input onChange={this.handleInputChange} type="radio" name="accessType" value="Normal" checked={(this.state.accessType == "Normal" ? "checked" : "" )}/>
										Normal
										<input onChange={this.handleInputChange} type="radio"  name="accessType" value="AI" checked={(this.state.accessType == "AI" ? "checked" : "" )}/>
										AI Widget
										<input onChange={this.handleInputChange} type="radio"  name="accessType" value="Both" checked={(this.state.accessType == "Both" ? "checked" : "" )}/>
										Both	
									</div> 
									 
								</div>	
								<div className="form-right">	
									<div className="form-group">
										<label>Priority: </label>
										<input type="text" name="priority" onChange={this.handleInputChange} className="form-control" value={this.state.priority}/>
										<div className="errorpriority"></div>
									</div>
									
									<div className="form-group">
										<div className="form-group">					
											<label>Status<span class="required" style={{ color: "red" }} > * </span> :</label>
											<Select 
											name="status"
											value={selectedOption?selectedOption:{ value: 'active', label: 'Active'}}
											options={lang.common.status_option} 
											isSearchable = {false}
											onChange={this.handleChange}
											/>
										</div> 
									</div>	
									<div className="form-group">
										<label>Image (jpeg,jpg,png,svg)<span class="required" style={{ color: "red" }} >* </span></label>
										<div className="choose-file">
											{this.state.isHidden && <div className="image_success"></div>}
											<span className="profile_btn"><input type="file" name="file" onChange={this.onChangeHandler} /></span>
										</div>
										{preview}
										{/* {image_preview?<a href="javascript:void(0);">X</a>:''} */}
										<div className="errorfile"></div>  
									</div>
									
								</div>										
							</div>		

							<div className="btn-group export">	
								<button className="btn btn_orange btn_minwid login_submit animate-btn2" type="submit" disabled={(this.state.Loading ===true)?true:false}> {this.state.Loading ===true? <span>updating</span>:<span>Submit</span>}
								</button>
							</div>
						</form>
					</div>				
				</div>	
			</div>
		</div>
    );
  }
}

export default (withRouter(Edit));